import { VISIBILITY } from "~/constants/filters/filters";

export const defaultFilters = {
  [VISIBILITY]: [],
};

const applyFilters = (activeFilters = defaultFilters, _filter) => {
  if (
    activeFilters[_filter]?.length > 0 ||
    typeof activeFilters[_filter] === "boolean"
  ) {
    return activeFilters[_filter];
  } else {
    return undefined;
  }
};

export const generateAssetTemplateQueryWhereCond = (
  activeFilters = defaultFilters,
) => {
  const customFields = [];

  for (const filter of Object.keys(activeFilters)) {
    if (!defaultFilters[filter] && activeFilters[filter]?.length) {
      customFields.push({
        fieldId: filter,
        value: activeFilters[filter],
      });
    }
  }

  const visibility_in = applyFilters(activeFilters, VISIBILITY);

  return {
    ...(visibility_in !== undefined ? { visibility_in } : {}),
  };
};
